import React from 'react'
import PropTypes from 'prop-types'

import { CONTAINER_IDS } from '../../lib/constants'
import styles from './Sidebar.module.scss'

function SidebarBody(props) {
  return (
    <div id={CONTAINER_IDS.sidebarBody} className={styles.sidebarContents + ' ' + props.className}>{props.children}</div>
  )
}

SidebarBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string
}

export default SidebarBody
